import { Grid, List } from "@mui/material";
import TopMenu from "../TopMenu";
import LeftNavigationItem from "./LeftNavigationItem";
//import { NavLinkOverviewItem } from "./LeftNavigationItem";
import LEFT_NAVIGATION_BUILDER from "./LeftNavigation.builders";

const LeftNavigation: React.FC = (): React.ReactElement => (
  <Grid container direction="column" spacing={2} wrap="nowrap">  
    <Grid item >
      <TopMenu/>
    </Grid>
    <Grid item >
      <List>
        {LEFT_NAVIGATION_BUILDER.map((item, i) => (
          <LeftNavigationItem key={i} path={item.path} title={item.title}/>
        ))}            
      </List>
    </Grid>
    {/* Uncomment the following line to add the navigation for the overview page 
      <Grid item >
        <NavLinkOverviewItem/>
      </Grid>
    */}    
  </Grid>      
);

export default LeftNavigation;